import * as React from 'react';
import { Container, Divider, Segment } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import FormularioDeRegistro from './componentes/FormularioDeRegistro';
import TablaDeAsignaciones from './componentes/TablaDeAsignaciones';
import TablaDeAtenciones from './componentes/TablaDeAtenciones';
import {
    Asesor,
    Asignacion,
    Atencion,
    MediosDeInformacionOption,
    PersonaARegistrar,
    Promotor,
} from './tipos';

interface State {
    asignaciones: Array<Asignacion>;
    asesores: Array<Asesor>;
    promotores: Array<Promotor>;
    atenciones: Array<Atencion>;
    mediosDeInformacionDeSistema: MediosDeInformacionOption;
}

const stateInicial: State = {
    asignaciones: [],
    asesores: [],
    promotores: [],
    atenciones: [],
    mediosDeInformacionDeSistema: [],
};

class TurnosYAtenciones extends React.Component<{}, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = stateInicial;

    public async componentDidMount() {
        this.actualizarListas();
    }

    public render() {
        return (
            <Container>
                <Segment>
                    <FormularioDeRegistro
                        mediosDeInformacion={this.state.mediosDeInformacionDeSistema}
                        promotores={this.state.promotores}
                        alPresionarRegistrar={this.registrarPersonaEnEspera}
                    />
                </Segment>
                <Divider hidden />
                <TablaDeAsignaciones
                    asesores={this.state.asesores}
                    asignaciones={this.state.asignaciones}
                    alAsignar={this.registrarAtencion}
                    alEliminar={this.eliminarPersonaEnEspera}
                />
                <Divider hidden />
                <Divider hidden />
                <TablaDeAtenciones
                    atenciones={this.state.atenciones}
                    alRevertir={this.revertirAtencion}
                />
            </Container>
        );
    }

    private readonly registrarPersonaEnEspera = async (datos: PersonaARegistrar) => {
        return clienteApi
            .ejecutar('registrarPersonaEnEsperaDeAsesor', {
                nombre: datos.nombre,
                rutOPasaporte: datos.rutOPasaporte,
                areaDeInteres: datos.areaDeInteres,
                medioDeInformacion: datos.medioDeInformacion,
            })
            .then(this.actualizarListas)
            .catch(this.context.mostrarModalError);
    };

    private readonly eliminarPersonaEnEspera = (id: string) => {
        clienteApi
            .ejecutar('eliminarPersonaRegistradaEnEsperaDeAsesor', { id })
            .then(this.actualizarListas)
            .catch(this.context.mostrarModalError);
    };

    private readonly registrarAtencion = (datos: { idAsesor: string; idPersona: string }) => {
        clienteApi
            .ejecutar('registrarAtencion', {
                idAsesor: datos.idAsesor,
                idPersona: datos.idPersona,
            })
            .then(this.actualizarListas)
            .catch(this.context.mostrarModalError);
    };

    private readonly revertirAtencion = (idAtencionARevertir: string) => {
        clienteApi
            .ejecutar('revertirAtencion', { id: idAtencionARevertir })
            .then(this.actualizarListas)
            .catch(this.context.mostrarModalError);
    };

    private readonly actualizarListas = () => {
        Promise.all([
            this.obtenerListaDeAsignacionesYAsesores(),
            this.promotoresYMediosDeInformacion(),
            this.obtenerListaDeAtenciones(),
        ]).catch(this.context.mostrarModalError);
    };

    private readonly obtenerListaDeAsignacionesYAsesores = async () => {
        return clienteApi
            .ejecutar('personasRegistradasEnEsperaDeAsesor')
            .then(resultados => {
                this.setState({
                    asignaciones: resultados.registros.map(asignacion => ({
                        idPersona: asignacion.persona.id,
                        nombre: asignacion.persona.nombre,
                        rutOPasaporte: asignacion.persona.rutOPasaporte,
                        asesor: {
                            id: asignacion.asesor.id,
                            nombre: asignacion.asesor.nombre,
                        },
                        asesorPreferente: asignacion.asesorPreferente.nombre,
                        areaDeInteres: asignacion.areaDeInteres,
                        medioDeInformacion: asignacion.medioDeInformacion,
                        horaDeLlegada: asignacion.horaDeLlegada,
                    })),
                    asesores: resultados.asesores,
                });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly promotoresYMediosDeInformacion = async () => {
        return clienteApi
            .ejecutar('datosIniciales')
            .then(resultados => {
                this.setState({
                    promotores: resultados.promotores,
                    mediosDeInformacionDeSistema: [
                        { key: 'promotor', value: 'promotor', text: 'Promotor' },
                        { key: 'otro', value: 'otro', text: 'Otro' },
                        ...resultados.mediosDeInformacion.map(({ tipo, texto }) => ({
                            key: tipo,
                            value: tipo,
                            text: texto,
                        })),
                    ],
                });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly obtenerListaDeAtenciones = async () => {
        return clienteApi
            .ejecutar('personasAtendidas')
            .then(resultados => {
                this.setState({
                    atenciones: resultados.map(atencion => ({
                        idAtencion: atencion.id,
                        horaDeAtencion: atencion.horaDeAtencion,
                        horaDeLlegada: atencion.horaDeLlegada,
                        asesor: atencion.asesor.nombre,
                        nombre: atencion.persona.nombre,
                        rutOPasaporte: atencion.persona.rutOPasaporte,
                        areaDeInteres: atencion.areaDeInteres,
                        medioDeInformacion: atencion.medioDeInformacion,
                    })),
                });
            })
            .catch(this.context.mostrarModalError);
    };
}

export default TurnosYAtenciones;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/index.tsx